import { ref, onUpdated, watch, computed } from "vue";
import "./assets/index-CgZzOVq6.js";
import "vue-demi";
import { u as useDataTestIdProp } from "./assets/index-BNd8MWnO.js";
import "./assets/index-vzP2cezV.js";
import "vue-router";
import "dompurify";
import "@vueuse/core";
import { n as normalizeComponent } from "./assets/_plugin-vue2_normalizer-VvYS6rEj.js";
import "vue-i18n";
import "./locales.js";
function useFocusableElements(activePanel) {
  const hasFocusableElements = ref(null);
  const focusableElementsList = [
    "[href]",
    'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
    "select:not([disabled]):not([aria-hidden])",
    "textarea:not([disabled]):not([aria-hidden])",
    "button:not([disabled]):not([aria-hidden])",
    "iframe",
    "object",
    "embed",
    "[contenteditable]",
    '[tabindex]:not([tabindex^="-"])'
  ];
  function checkIfPanelHasFocusableElements() {
    var _a, _b, _c;
    if ((_a = activePanel.value) == null ? void 0 : _a.querySelectorAll) {
      return ((_c = (_b = activePanel.value) == null ? void 0 : _b.querySelectorAll(focusableElementsList)) == null ? void 0 : _c.length) > 0;
    }
    return false;
  }
  function setHasFocusableElements() {
    hasFocusableElements.value = checkIfPanelHasFocusableElements();
  }
  onUpdated(() => {
    setHasFocusableElements();
  });
  watch(
    activePanel,
    () => {
      setHasFocusableElements();
    },
    {
      immediate: true
    }
  );
  return {
    hasFocusableElements,
    setHasFocusableElements
  };
}
const XTabsPanel$1 = "_XTabsPanel_apjzn_1";
const style0 = {
  XTabsPanel: XTabsPanel$1
};
const { createTestIdProp, setupTestId } = useDataTestIdProp();
const __default__ = {
  name: "XTabsPanel"
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    tabName: {
      type: String,
      default: ""
    },
    activeTab: {
      type: String,
      default: null
    },
    isAlwaysVisible: {
      type: Boolean,
      default: false
    },
    ...createTestIdProp()
  },
  setup(__props) {
    const props = __props;
    const activePanelElement = ref(null);
    const { formatTestId } = setupTestId(props);
    const { hasFocusableElements } = useFocusableElements(activePanelElement);
    const canShowPanel = computed(() => props.tabName === props.activeTab || props.isAlwaysVisible);
    return { __sfc: true, createTestIdProp, setupTestId, props, activePanelElement, formatTestId, hasFocusableElements, canShowPanel };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _setup.canShowPanel ? _c("div", { ref: "activePanelElement", class: _vm.$style.XTabsPanel, attrs: { "id": `panel-${_vm.tabName}`, "aria-labelledby": `tab-${_vm.tabName}`, "data-testid": _setup.formatTestId(`${_vm.tabName}-panel`), "role": "tabpanel", "tabindex": _setup.hasFocusableElements ? -1 : 0 } }, [_vm._t("default")], 2) : _vm._e();
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const XTabsPanel = __component__.exports;
export {
  XTabsPanel as default
};
